var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('v-card-title', [_vm._v("Реактивация лидов")]), _c('v-card-text', [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": "Лимит"
    },
    model: {
      value: _vm.filter.limit,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "limit", _vm._n($$v));
      },
      expression: "filter.limit"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.sources,
      "item-value": "id",
      "item-text": "name",
      "label": "Источник",
      "clearable": ""
    },
    model: {
      value: _vm.filter.source,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "source", $$v);
      },
      expression: "filter.source"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "3"
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.areas,
      "item-value": "id",
      "item-text": "name",
      "label": "Область права",
      "clearable": ""
    },
    model: {
      value: _vm.filter.area,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "area", $$v);
      },
      expression: "filter.area"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "2"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.fetch();
      }
    }
  }, [_vm._v("Показать")])], 1)], 1), _vm.loading ? _c('v-skeleton-loader', {
    attrs: {
      "type": "table-row@5"
    }
  }) : _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "item-key": "requestId"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn(_ref) {
        var items = _ref.items;
        return [_c('tbody', _vm._l(items, function (item) {
          return _c('tr', {
            key: item.requestId
          }, [_c('td', [_c('a', {
            on: {
              "click": function click($event) {
                return _vm.editRequest(item.requestId);
              }
            }
          }, [_vm._v(_vm._s(item.requestId))])]), _c('td', [_vm._v(_vm._s(item.userName))]), _c('td', [_vm._v(_vm._s(item.userPhone))]), _c('td', [_c('v-chip', {
            attrs: {
              "small": "",
              "color": item.state.chipColor
            }
          }, [_vm._v(_vm._s(item.state.text))])], 1), _c('td', [_vm._v(_vm._s(item.failureReason ? item.failureReason.text : '—'))]), _c('td', [item.score !== null && item.score !== undefined ? _c('v-chip', {
            attrs: {
              "small": "",
              "dark": "",
              "color": _vm.$helper.aiScoreColor(item.score)
            },
            on: {
              "click": function click($event) {
                return _vm.showScoreDetail(item.requestId);
              }
            }
          }, [_vm._v(_vm._s(item.score))]) : _c('span', {
            staticClass: "grey--text"
          }, [_vm._v("—")])], 1), _c('td', [_vm._v(_vm._s(item.createdAtDate))]), item.recommendations && item.recommendations.length ? _c('td', [_vm._v(_vm._s(item.recommendations[0]))]) : _c('td', [_vm._v(_vm._s(item.hint))])]);
        }), 0)];
      }
    }])
  })], 1), _c('v-bottom-sheet', {
    attrs: {
      "fullscreen": "",
      "scrollable": "",
      "persistent": "",
      "retain-focus": false
    },
    model: {
      value: _vm.dialog.requestEdit.modal,
      callback: function callback($$v) {
        _vm.$set(_vm.dialog.requestEdit, "modal", $$v);
      },
      expression: "dialog.requestEdit.modal"
    }
  }, [_c('v-card', {
    staticStyle: {
      "background": "none"
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "height": "100vh"
    }
  }, [_vm.editedRequest ? _c('RequestUpdatePage', {
    key: _vm.editedRequestKey,
    attrs: {
      "id": _vm.editedRequest
    },
    on: {
      "closeAndUpdate": _vm.closeEditAndFetch,
      "updated": _vm.fetch,
      "fetchGrid": _vm.fetch,
      "closeEdit": _vm.closeEdit
    }
  }) : _vm._e()], 1)], 1)], 1), _c('ScoreDetailDialog', {
    attrs: {
      "dialog-visible": _vm.dialog.scoreDetail.modal,
      "request-id": _vm.scoreDetailRequestId
    },
    on: {
      "close": function close($event) {
        _vm.dialog.scoreDetail.modal = false;
      },
      "recomputed": function recomputed($event) {
        return _vm.fetch();
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }